import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TooltipComponent } from './tooltip.component';
import { TooltipRoutingModule } from './tooltip-routing.module';

import { CatalogueModule } from './../../component/catalogue/catalogue.module';
import { DemoModule } from './../../component/demo/demo.module';
import { CodeModule } from './../../component/code/code.module';

import {TooltipModule} from "../../component/ing/tooltip/tooltip";
import {TableModule} from "../../component/ing/table/table";
import {InputTextModule} from "../../component/ing/inputtext/inputtext";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TooltipRoutingModule,
    CatalogueModule,
    DemoModule,
    CodeModule,
    TooltipModule,
    TableModule,
    InputTextModule
  ],
  declarations: [TooltipComponent]
})
export class TooltipDemoModule { }



// WEBPACK FOOTER //
// ./src/app/view/tooltip/tooltipDemo.module.ts